const rezdyBaseUrl = 'https://tassietours.rezdy.com';
const rezdyImageBaseUrl = 'https://img.rezdy.com/PRODUCT_IMAGE/27965';

/**
 * @param {{ productCode: string; rezdyId: number; amount: number; imageFile: string }} card
 */
function createGiftCard(card) {
	const { productCode, rezdyId, amount, imageFile } = card;

	return {
		productCode,
		rezdyId,
		amount,
		currency: 'AUD',
		title: `$${amount} Gift Card`,
		description: `Give the gift of adventure with a $${amount} Tassie Tours Gift Card. It can be used towards any Tassie Tours product, so they can choose the Tasmanian experience that suits them.`,
		url: `${rezdyBaseUrl}/${rezdyId}/${amount}-gift-card`,
		image: `${rezdyImageBaseUrl}/${imageFile}`
	};
}

export const giftCards = [
	createGiftCard({
		productCode: 'PEU18S',
		rezdyId: 779538,
		amount: 100,
		imageFile: 'Travel_Voucher___TT__2__lg.png'
	}),
	createGiftCard({
		productCode: 'PMLWFT',
		rezdyId: 779539,
		amount: 200,
		imageFile: 'Travel_Voucher___TT__3__lg.png'
	}),
	createGiftCard({
		productCode: 'PBHNA8',
		rezdyId: 779540,
		amount: 300,
		imageFile: 'Travel_Voucher___TT__4__lg.png'
	}),
	createGiftCard({
		productCode: 'P5UZM1',
		rezdyId: 779541,
		amount: 400,
		imageFile: 'Travel_Voucher___TT__5__lg.png'
	}),
	createGiftCard({
		productCode: 'PAYUZB',
		rezdyId: 779542,
		amount: 500,
		imageFile: 'Travel_Voucher___TT__6__lg.png'
	})
];
